import { useContext } from 'react';
import {
  CommandRegistryHelpDialogContext,
  type Trigger,
} from '@frameio/shared/commands';
import { Box, MenuButton, type ThemeSpaces } from '@frameio/vapor';
import { IconKeyboard } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/KeyboardShortcutNavItem';

TEXT.DEFINE({
  /** Menu item label that opens the keyboard shortcuts help dialog from the account avatar menu */
  label: 'Keyboard Shortcuts',
});

type KeyboardShortcutNavItemProps = {
  labelPaddingLeft?: ThemeSpaces;
  /** Which surface opened the dialog — reported on the analytics event. */
  trigger: Trigger;
};

export function KeyboardShortcutNavItem({
  labelPaddingLeft,
  trigger,
}: KeyboardShortcutNavItemProps) {
  const { toggleKeyboardShortcutsHelpDialogOpen } = useContext(
    CommandRegistryHelpDialogContext
  );

  const label = labelPaddingLeft ? (
    <Box paddingLeft={labelPaddingLeft}>{TEXT.label}</Box>
  ) : (
    TEXT.label
  );

  return (
    <MenuButton
      iconBefore={<IconKeyboard />}
      isLink={false}
      onClick={() => toggleKeyboardShortcutsHelpDialogOpen(trigger)}
    >
      {label}
    </MenuButton>
  );
}
